var React = require('react');

function BurgerIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.66667 20.5H28.3333C29.25 20.5 30 19.75 30 18.8333C30 17.9167 29.25 17.1667 28.3333 17.1667H1.66667C0.75 17.1667 0 17.9167 0 18.8333C0 19.75 0.75 20.5 1.66667 20.5ZM1.66667 12.1667H28.3333C29.25 12.1667 30 11.4167 30 10.5C30 9.58333 29.25 8.83333 28.3333 8.83333H1.66667C0.75 8.83333 0 9.58333 0 10.5C0 11.4167 0.75 12.1667 1.66667 12.1667ZM0 2.16667C0 3.08333 0.75 3.83333 1.66667 3.83333H28.3333C29.25 3.83333 30 3.08333 30 2.16667C30 1.25 29.25 0.5 28.3333 0.5H1.66667C0.75 0.5 0 1.25 0 2.16667Z","fill":"#4E4E4E"}));
}

BurgerIcon.defaultProps = {"width":"30","height":"21","viewBox":"0 0 30 21","fill":"none"};

module.exports = BurgerIcon;

BurgerIcon.default = BurgerIcon;
